/* ============================================================
   toy-collection.js
   Drop into: assets/toy-collection.js
   Add before </body> in theme.liquid:
     <script src="{{ 'toy-collection.js' | asset_url }}" defer></script>
   ============================================================ */

(function () {
  'use strict';

  /* ── Initialise on DOM ready ──────────────────────────── */
  document.addEventListener('DOMContentLoaded', init);

  function init () {
    initFilterGroups();
    initSortSelect();
    initMobileFilterDrawer();
    initAddToCartButtons();
  }

  /* ── Collapsible filter groups ────────────────────────── */
  function initFilterGroups () {
    document.querySelectorAll('.tc-filter-group__header').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!expanded));
      });
    });
  }

  /* ── Sort select → reload with sort_by param ──────────── */
  function initSortSelect () {
    var select = document.getElementById('tc-sort-select');
    if (!select) return;

    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.href = url.toString();
    });

    /* Restore selected value from URL on page load */
    var current = new URL(window.location.href).searchParams.get('sort_by');
    if (current) select.value = current;
  }

  /* ── Mobile filter drawer ─────────────────────────────── */
  function initMobileFilterDrawer () {
    var sidebar  = document.querySelector('.tc-sidebar');
    var overlay  = document.querySelector('.tc-sidebar-overlay');
    var toggleBtn = document.querySelector('.tc-filter-toggle');
    var closeBtn = document.querySelector('.tc-sidebar__close');
    if (!sidebar || !overlay || !toggleBtn) return;

    function openDrawer () {
      sidebar.classList.add('tc-sidebar--open');
      overlay.classList.add('tc-sidebar-overlay--visible');
      document.body.style.overflow = 'hidden';
      closeBtn && closeBtn.focus();
    }
    function closeDrawer () {
      sidebar.classList.remove('tc-sidebar--open');
      overlay.classList.remove('tc-sidebar-overlay--visible');
      document.body.style.overflow = '';
      toggleBtn.focus();
    }

    toggleBtn.addEventListener('click', openDrawer);
    closeBtn && closeBtn.addEventListener('click', closeDrawer);
    overlay.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });
  }

  /* ── Add-to-cart buttons (AJAX) ───────────────────────── */
  function initAddToCartButtons () {
    document.querySelectorAll('.tc-add-btn').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var variantId = btn.dataset.variantId;
        if (!variantId || btn.disabled) return;

        btn.classList.add('tc-add-btn--loading');
        btn.textContent = '…';

        fetch('/cart/add.js', {
          method:  'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('Cart error');
            return res.json();
          })
          .then(function () {
            btn.classList.remove('tc-add-btn--loading');
            btn.classList.add('tc-add-btn--added');
            btn.innerHTML = '&#10003; Added';
            updateCartCount();
            setTimeout(function () {
              btn.classList.remove('tc-add-btn--added');
              btn.innerHTML = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4zM3 6h18M16 10a4 4 0 01-8 0"/></svg> Add';
            }, 2200);
          })
          .catch(function () {
            btn.classList.remove('tc-add-btn--loading');
            btn.textContent = 'Error';
            setTimeout(function () {
              btn.innerHTML = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4zM3 6h18M16 10a4 4 0 01-8 0"/></svg> Add';
            }, 2200);
          });
      });
    });
  }

  /* ── Update cart bubble count in header ───────────────── */
  function updateCartCount () {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        /* Targets the most common cart-count selectors across themes */
        var targets = document.querySelectorAll(
          '.cart-count, .cart__count, [data-cart-count], .header__cart-count, #cart-count'
        );
        targets.forEach(function (el) {
          el.textContent = cart.item_count;
          if (cart.item_count > 0) el.removeAttribute('hidden');
        });
      });
  }
})();
